import * as React from 'react';
import type { FieldArrayFieldsProps } from 'redux-form';

import Pill from './Pill';

interface OwnProps<T> {
	items: FieldArrayFieldsProps<T>;
	labelKey?: string;
	emptyLabel: string;
	destructiveAction: (index: number) => void;
	isField?: boolean;
	renderItem?: (item: T) => React.JSX.Element | string;
}

interface OwnPropsWithModal<T> {
	skipConfirmationModal?: false;
	modalBody: (original: T) => React.JSX.Element;
	modalTitle: string;
}

interface OwnPropsWithoutModal {
	skipConfirmationModal: true;
	modalBody?: undefined;
	modalTitle?: undefined;
}

type Props<T> = OwnProps<T> & (OwnPropsWithModal<T> | OwnPropsWithoutModal);

function PillsList<T,>(props: React.PropsWithChildren<Props<T>>) {
	const {
		items,
		destructiveAction,
		skipConfirmationModal,
		labelKey,
		modalBody,
		modalTitle,
		emptyLabel,
		renderItem,
	} = props;

	const renderPill = (_: string, index: number) => {
		return (
			<Pill
				index={index}
				item={items.get(index)}
				key={`pill#${index}`}
				labelKey={labelKey}
				modalBody={modalBody}
				modalTitle={modalTitle}
				removeItem={destructiveAction}
				renderItem={renderItem}
				skipConfirmationModal={skipConfirmationModal}
			/>
		);
	};

	return (
		<div className="pills">
			{items.map(renderPill)}
			{!items.length &&
				<div className="pills__empty">{emptyLabel}</div>
			}
		</div>
	);
}

export default React.memo(PillsList) as typeof PillsList;
